import { BlogEntityEnum, BlogPageEnum } from 'modules/automation-rules/enums/automation-rule-enum'
import {
  BlogEntityDataInterface,
  FilterBaseApiInterface,
  FilterBlogApiInterface,
} from 'modules/automation-rules/types/automation-rule-filter-interface'
import { AutomationRuleBaseDataInterface } from 'modules/automation-rules/types/automation-rule-interface'
import { PipelineInterface } from 'modules/crm/types/pipeline-interface'
import { BaseApiInterface } from 'modules/digital-product/resources/hooks/use-digital-resources'
import { ReactNode } from 'react'
import { DataWithPaginationInterface } from 'shared/types/pagination-interface'

export const getData = (
  apiData?: FilterBaseApiInterface[],
): AutomationRuleBaseDataInterface[] | undefined =>
  apiData?.map(el => ({ id: el.id, caption: el.name }))

export const geDataFromApiData = (
  apiData?: BaseApiInterface,
): AutomationRuleBaseDataInterface[] | undefined => {
  if (!apiData) return
  return !!apiData ? apiData.items.map(el => ({ id: el.id, caption: el.name })) : []
}

export const getPipelineData = (
  apiData?: DataWithPaginationInterface<Pick<PipelineInterface, 'name' | 'id'>>,
): AutomationRuleBaseDataInterface[] | undefined => {
  if (!apiData) return
  return !!apiData ? apiData.items.map(el => ({ id: el.id, caption: el.name })) : []
}

export const getDataFromObj = ({
  id,
  name,
  customCaption,
}: {
  id?: number
  name?: string
  customCaption?: ReactNode
}): AutomationRuleBaseDataInterface[] => [{ id: id || 0, caption: name || '', customCaption }]

export const getBlogEntityData = (
  apiData?: FilterBlogApiInterface[],
): BlogEntityDataInterface | undefined =>
  apiData?.reduce((acc, cur) => {
    return {
      ...acc,
      [cur.id]: {
        [BlogEntityEnum.blog_post_layout]: cur.blog_post_layout,
        [BlogEntityEnum.blog_layout]: cur.blog_layout,
      },
    }
  }, {} as BlogEntityDataInterface)

export const getBlogEntityId = (
  entityData: BlogEntityDataInterface,
  blogId: number,
  entity?: BlogEntityEnum | BlogPageEnum,
) => {
  if (entity === BlogEntityEnum.blog_layout || entity === BlogEntityEnum.blog_post_layout) {
    return entityData[blogId][entity]
  } else {
    return undefined
  }
}

export const getBlogEntityValue = (entity?: BlogEntityEnum | BlogPageEnum) => {
  return entity === BlogPageEnum.blog_static ||
    entity === BlogPageEnum.blog_home ||
    entity === BlogPageEnum.blog_post_listing ||
    entity === BlogPageEnum.blog_search
    ? BlogEntityEnum.blog_page
    : BlogEntityEnum[entity as keyof typeof BlogEntityEnum]
}
